// extracted by mini-css-extract-plugin
module.exports = {"container":"Switcher_container__eFVoq","point":"Switcher_point__SCwac","active":"Switcher_active__z8Txh"};